export function getNumberOfPersonSlotsRemaining(
  userID,
  householdID,
  signupItem
) {
  try {
    const { maxSingleUserSlots } = signupItem;

    const currentSingleUserSlots = getCurrentNumberOfSlotsForUser(
      signupItem.respondents,
      userID,
      householdID
    );
    return maxSingleUserSlots - currentSingleUserSlots;
  } catch (e) {
    return 0;
  }
}

function getCurrentNumberOfSlotsForUser(respondents, userID, householdID) {
  // first, we look for a non-household user
  const nonHHRespondent = respondents.find((r) => r.userID === userID);

  if (nonHHRespondent) {
    return nonHHRespondent.numberOfSlots;
  } else {
    // since a non-household user wasn't found, look for the household
    // const household = respondents.find((r) => r.householdID === householdID);

    // counting the number of "person slots" for a household gets a bit wonky.
    // we don't use numberOfSlots. Instead, we look for the total # of additionalName entries,
    // and add 1 to it (for "the household"), and that is considered our total.
    // const numOfAdditionalNames = household.householdRespondents.filter(
    //   (r) => r.isAdditionalName
    // ).length;
    // return numOfAdditionalNames + 1;

    const household = respondents.find((r) => r.householdID === householdID);
    return household.householdRespondents.length;
  }
}

export function getNumberOfItemSlotsRemaining(signupItem) {
  try {
    const { totalSlots, slotsTaken } = signupItem;

    return totalSlots - slotsTaken;
  } catch (e) {
    return 0;
  }
}
